import { getCurrentDevice } from './utils';

import fullsizeImagesUI from './fullsize';
import slidersUI from './sliders';
import currentYear from './current-year';
import shaveUI from './shave-ui';
import scrollToSection from './scroll-to-section';
import filtersUI from './filtersUI';

; (function (window, document, $) {
	$('a[href^="tel"]').each(function () {
		const linkHref = $(this).attr('href');

		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$('.js-nav-btn').on('click', function (event) {
		//event.preventDefault();

		$(this).toggleClass('active');

		$('.header .nav').toggleClass('active');
	});

	$('.js-load-more').on('click', function (event) {
		event.preventDefault();

		$(this).parent().addClass('hide');
		$(this).parents('.js-section-load').addClass('loaded');
	})

	var getslide = $('.hero-acc .box').length - 1;

	var slidecal = 280 / getslide + 'px';

	$('.box').css({ "width": slidecal });

	$('.js-nav-lang').on('click', function (event) {
		//event.preventDefault();

		$(this).find('ul').slideToggle();
	})

	$('.js-toggle-search').on('click', function (event) {
		event.preventDefault();

		$(this).parent('.search').toggleClass("active");
	})

	$('.js-open-popup').on('click', function (event) {
		event.preventDefault();
		$(this).parents('.member').find(".member__popup").toggleClass("active");
		$("body").toggleClass("fixed");
	})

	$('.box').click(function () {
		$('.box').removeClass('active toggled');
		$(this).addClass('active');
		const $activeElement = $('.box.active');
		const $elementsBeforeActive = $('.box').slice(0, $('.box').index($activeElement)).addClass('toggled');
	});

	fullsizeImagesUI();

	slidersUI();

	// Add js-year-container class where you want to print the current year
	currentYear();

	shaveUI();

	scrollToSection();

	filtersUI();
})(window, document, window.jQuery);
